export default "__VITE_ASSET__d0c4d6e0__"